export default __webpack_public_path__ + "media/images/features/yado/title_pc-16c72b477b4d26da64a7097e854d3221.jpg";